"use client";
import Image from "next/image";
import React from "react";
import { CarModel } from "./CarsInfo";
import CustomLink from "../CustomLink";
import { useRouter } from "next/router";

const CarModelCard: React.FC<CarModel> = ({
  imageSrc,
  logoSrc,
  altText,
  carLink,
  preserveLogoAspect,
}) => {
  const router = useRouter();

  const handleNavigate = () => {
    router.push(carLink);
  };

  const handleKeyDown: React.KeyboardEventHandler<HTMLDivElement> = (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      handleNavigate();
    }
  };
  return (
    <div
      className="flex justify-center items-center max-md:w-[27%] max-md:hover:w-[35%] w-3/5 hover:w-full transition-all duration-300 ease-in-out rounded-xl cursor-pointer"
      onClick={handleNavigate}
      onKeyDown={handleKeyDown}
      role="link"
      tabIndex={0}
      aria-label={altText}
    >
      <div
        className="flex relative h-80 overflow-y-hidden rounded-xl flex-col  w-full origin-left"
        style={{
          backgroundImage: `linear-gradient(to bottom, rgb(0, 0, 0, 0.8), transparent, rgb(0, 0, 0, 0.8)), url('${imageSrc}')`,
          backgroundPosition: "center center",
          backgroundSize: "cover",
        }}
      >
        <div className="w-full py-4 px-3 relative flex flex-col items-center transition-all duration-500 justify-between h-full hover:pb-20">
          <Image
            loading="lazy"
            src={logoSrc}
            width={400}
            height={400}
            alt={`${altText} logo`}
            className={
              preserveLogoAspect
                ? "mx-auto h-auto max-h-14 w-auto max-w-[90%] object-contain"
                : "mx-auto w-full"
            }
          />
          <CustomLink
            href={carLink}
            className="border text-sm -mb-16 relative text-white px-5 py-2 rounded"
            onClick={(e) => e.stopPropagation()}
          >
            SAIBA MAIS
          </CustomLink>
        </div>
      </div>
    </div>
  );
};

export default CarModelCard;
